import React, { useEffect, useState, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Col } from "reactstrap";
import { CustomButton } from "../../Common/Components/Button/CustomButton";
import { useTranslation } from "react-i18next";
import useApiCallService from "../../Common/Helpers/ApiCall";
import ResponseEconomicReportModel from "../Models/ResponseEconomicReportModel";
import { ADMIN_PATHS } from "../../config";
import { AccountRowView } from "../../DigitalAccount/Components/AccountRowView";
import { EconomicReportDetailsView } from "./EconomicReportDetailsView";

const AdminEconomicReportInfo = () => {
    const { ApiCall } = useApiCallService();
    const memoizedApiCall = useCallback(ApiCall, []);
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();

    const idValue = new URLSearchParams(window.location.search).get('id');
    const [economicReportData, setEconomicReportData] = useState(new ResponseEconomicReportModel());
    const [hasFetched, setHasFetched] = useState(false);

    useEffect(() => {
        const fetchEconomicReport = async () => {
            if (idValue && !hasFetched) {
                try {
                    const apiCallOptions = {
                        method: "get",
                        url: `/export-data/admin/info-economic-report?id=${idValue}`,
                    };
                    const handleApiResponse = (response) => {
                        setEconomicReportData(response);
                        setHasFetched(true);
                    };
                    await memoizedApiCall(apiCallOptions, handleApiResponse);
                } catch (error) {
                    console.error("Error fetching economic report details:", error);
                }
            }
        };

        fetchEconomicReport();
    }, [idValue, memoizedApiCall, hasFetched]);

    const handleBack = () => {
        navigate(ADMIN_PATHS.ADMIN_ECONOMIC_REPORT);
    };

    return (
        <>
            <Col lg={1} className="px-0">
                <CustomButton
                    text={t('button.back')}
                    icon={'bx bx-chevron-left'}
                    buttonSize={'small'}
                    customClasses={'ms-3 mb-3'}
                    onClick={handleBack}
                />
            </Col>

            {hasFetched && economicReportData !== null ? (
                <EconomicReportDetailsView data={economicReportData}/>
            ) : null}
        </>
    );
};

export default AdminEconomicReportInfo;